export function resolveQueryData<TData, TFallback>(
  data: TData | undefined,
  fallback: TFallback,
): TData | TFallback {
  return data !== undefined ? data : fallback;
}
